import { where } from "firebase/firestore"
import _ from "lodash"
import { dispatchProps } from "../../../cnr/reducers/reducerHelpers/dispatchProps"
import { createRefPath } from "../../appData/appRefPaths"
import { mergePromise } from "../../promises/mergePromise"

export const fsUpdate_mergeData = (props) => {

  const {
    baseRef,
    dispatch,
    ufProps,
    database_fns
  } = props

  const { refPath, directCollection } = baseRef
  let { vit, allInfo, itemData } = ufProps ?? {}

  if (allInfo) {
    const coll = directCollection ? directCollection : vit
    const _refPath = createRefPath([coll], refPath)
    const wheres = [where('name', '==', allInfo.name)]
    database_fns.get_data({ refPath: _refPath, wheres }).then(item => {
      if (!_.isEmpty(item)) {
        const _updateRef = createRefPath([coll, item.id], refPath)
        database_fns.update_docc({
          refPath: _basePath,
          data: allInfo,
          callback: dispatch
        })
      } else {
        const _setRef = createRefPath([coll, item.id], refPath)
        database_fns.update_doc({ refPath: _setRef }, allInfo, dispatch)
      }
    })
  } else {
    mergePromise(database_fns, refPath, vit, directCollection, itemData).then(pr => {
      dispatch({ type: dispatchProps.success, dispatch })
    }).catch(error => {
      dispatch({ type: dispatchProps.error, error, dispatch })
    })
  }
}